// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"_38AIjGN","iframe":"_YhXDA7C"};